import { createSlice } from '@reduxjs/toolkit';
import { showDrawer } from 'cw-ui-core';
import { EDIT_PRODUCT_DRAWER } from './constants';

export const initialState = {
    products: {
        rows: [],
        pageInfo: {},
        isLoading: false,
        errors: '',
    },
    searchText: '',
    editProduct: {
        editInstanceId: '',
    },
    deleteProduct: {
        isLoading: false,
        deleteClientId: '',
        errors: '',
    },
    showDeleteProductModal: false,
};
export const productsSliceId = 'products_v2';

const slice = createSlice({
    name: productsSliceId,
    initialState,
    reducers: {
        fetchProducts(state) {
            state.products = {
                ...state.products,
                rows: [],
                isLoading: true,
                errors: '',
                pageInfo: {
                    ...state.products.pageInfo,
                },
            };
        },
        fetchProductsSuccess(state, action) {
            const { rows, pageInfo } = action.payload;

            state.products = {
                ...state.products,
                rows,
                isLoading: false,
                errors: '',
                pageInfo: {
                    ...state.products.pageInfo,
                    ...pageInfo,
                },
            };
        },
        fetchProductsFailure(state, action) {
            const { error } = action.payload;
            state.products = {
                ...state.products,
                rows: [],
                isLoading: false,
                errors: error,
                pageInfo: {
                    ...state.products.pageInfo,
                },
            };
        },
        onSearchChange: (state, action) => {
            const { value } = action.payload;
            state.searchText = value;
        },
        onCancelSearch: state => {
            state.searchText = '';
        },
        onProductEdit: (state, action) => {
            const { editInstanceId } = action.payload;
            state.editProduct = {
                ...state.editProduct,
                editInstanceId,
            };

            showDrawer(EDIT_PRODUCT_DRAWER, {
                editInstanceId,
            });
        },
        onGenerateToken: () => {},
        onDeleteProduct: state => {
            state.deleteProduct = {
                ...state.deleteProduct,
                isLoading: true,
            };
        },
        onDeleteProductSuccess: state => {
            state.deleteProduct = {
                ...state.deleteProduct,
                isLoading: false,
            };
            state.showDeleteProductModal = false;
        },
        onDeleteProductFailure: (state, action) => {
            const { errors } = action.payload;
            state.deleteProduct = {
                ...state.deleteProduct,
                isLoading: false,
                errors,
            };
            state.showDeleteProductModal = false;
        },
        toggleDeleteProductModal: (state, action) => {
            const { isOpen, deleteClientId } = action.payload;
            state.showDeleteProductModal = isOpen;
            state.deleteProduct = {
                ...state.deleteProduct,
                deleteClientId,
            };
        },
    },
});

export const {
    fetchProducts,
    fetchProductsSuccess,
    fetchProductsFailure,
    onSearchChange,
    onCancelSearch,
    onProductEdit,
    onGenerateToken,
    onDeleteProduct,
    onDeleteProductSuccess,
    onDeleteProductFailure,
    toggleDeleteProductModal,
} = slice.actions;

export default slice.reducer;
